(function (global) {
  'use strict';

  if (global.CPStorefrontMemory) return;

  var KEY = 'cp_storefront_memory_v2';
  var memoryFallback = { version: 2, saved: [], viewed: [], recipes: [] };
  var persistent = true;
  var pendingMemory = false;

  function safeArray(value) {
    return Array.isArray(value) ? value.filter(Boolean) : [];
  }

  function publicURL(value) {try{var u=new URL(value,global.location.origin);if(u.origin!==global.location.origin||!/^\/(products|pages|collections)\/[a-z0-9-]+\/?$/.test(u.pathname))return '';var v=u.searchParams.get('variant');return u.pathname+(/^\d+$/.test(v||'')?'?variant='+v:'')+(/^#[a-zA-Z0-9_-]{1,120}$/.test(u.hash)?u.hash:'');}catch(_){return '';}}

  function cleanProduct(product) {
    if (!product || !product.handle || !product.url || !product.title) return null;
    return {
      handle: String(product.handle),
      title: String(product.title),
      url: publicURL(product.url),
      price: product.price ? String(product.price) : '',
      image: product.image ? String(product.image) : '',
      imageAlt: product.imageAlt ? String(product.imageAlt) : String(product.title),
      variant: product.variant ? Number(product.variant) : null,
      available: Boolean(product.available),
      touchedAt: Date.now()
    };
  }

  function cleanRecipe(recipe) {
    if (!recipe || !recipe.key || !recipe.url || !recipe.title) return null;
    return {
      key: String(recipe.key),
      title: String(recipe.title),
      url: publicURL(recipe.url),
      image: recipe.image ? String(recipe.image) : '',
      touchedAt: Date.now()
    };
  }

  function recent(x){return Number.isFinite(x.touchedAt)&&Date.now()>=x.touchedAt&&Date.now()-x.touchedAt<2592000000;}

  function normalise(data) {
    data = data && typeof data === 'object' ? data : {};
    return {
      version: 2,
      saved: safeArray(data.saved).filter(recent).map(function(x){var v=cleanProduct(x);if(v)v.touchedAt=x.touchedAt;return v;}).filter(function(x){return x&&x.url;}).slice(0,20),
      viewed: safeArray(data.viewed).filter(recent).map(function(x){var v=cleanProduct(x);if(v)v.touchedAt=x.touchedAt;return v;}).filter(function(x){return x&&x.url;}).slice(0,20),
      recipes: safeArray(data.recipes).filter(recent).map(function(x){var v=cleanRecipe(x);if(v)v.touchedAt=x.touchedAt;return v;}).filter(function(x){return x&&x.url;}).slice(0,12)
    };
  }

  function readRaw(key) {
    try {
      return JSON.parse(global.localStorage.getItem(key) || 'null');
    } catch (error) {
      persistent = false;
      return null;
    }
  }

  function read() {
    if (pendingMemory) return memoryFallback = normalise(memoryFallback);
    var stored = readRaw(KEY);
    if (stored) {
      memoryFallback = normalise(stored);
      return memoryFallback;
    }
    return memoryFallback = normalise(memoryFallback);
  }

  function write(data) {
    memoryFallback = normalise(data);
    try {
      global.localStorage.setItem(KEY, JSON.stringify(memoryFallback));
      persistent = true;
      pendingMemory = false;
    } catch (error) {
      persistent = false;
      pendingMemory = true;
    }
    try {
      document.dispatchEvent(new CustomEvent('cp:memory:change', { detail: memoryFallback }));
    } catch (error) {}
    return persistent;
  }

  function upsert(list, item, key, limit) {
    var value = item && item[key];
    if (!value) return safeArray(list);
    return [item].concat(safeArray(list).filter(function (existing) {
      return existing && existing[key] !== value;
    })).slice(0, limit);
  }

  function migrate() {
    if (readRaw(KEY)) return;
    var data = read();
    var oldSaved = readRaw('cp_b2c_shelf_v1');
    var oldViewed = readRaw('cp_recent_products_v1');
    safeArray(oldSaved).forEach(function (item) {
      var product = cleanProduct(item);
      if (product) data.saved = upsert(data.saved, product, 'handle', 20);
    });
    safeArray(oldViewed).forEach(function (item) {
      var product = cleanProduct(item);
      if (product) data.viewed = upsert(data.viewed, product, 'handle', 20);
    });
    write(data);
  }

  var api = {
    saved: function () { return read().saved.slice(); },
    viewed: function () { return read().viewed.slice(); },
    recipes: function () { return read().recipes.slice(); },
    isPersistent: function () { return persistent; },
    saveProduct: function (product) {
      var clean = cleanProduct(product);
      if (!clean) return false;
      var data = read();
      data.saved = upsert(data.saved, clean, 'handle', 20);
      return write(data);
    },
    removeSaved: function (handle) {
      var data = read();
      data.saved = data.saved.filter(function (item) { return item.handle !== handle; });
      return write(data);
    },
    recordView: function (product) {
      var clean = cleanProduct(product);
      if (!clean) return false;
      var data = read();
      data.viewed = upsert(data.viewed, clean, 'handle', 20);
      return write(data);
    },
    saveRecipe: function (recipe) {
      var clean = cleanRecipe(recipe);
      if (!clean) return false;
      var data = read();
      data.recipes = upsert(data.recipes, clean, 'key', 12);
      return write(data);
    },
    removeRecipe: function (key) {
      var data = read();
      data.recipes = data.recipes.filter(function (item) { return item.key !== key; });
      return write(data);
    }
  };

  global.CPStorefrontMemory = api;
  migrate();
})(window);
